import utils from '@/js/utils';
import MENU_ANALYTIC_SERVICES from '@/configs/menus/analytic_services.menu';
export default [{
  path: '/resources/MyResources',
  name: 'MyResources',
  component: function component() {
    return import('@/apps/analytic-services/components/MyResourcesPage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('MyResources', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/resources/ContResourcesRequest',
  name: 'ContResourcesRequest',
  component: function component() {
    return import('@/apps/analytic-services/components/ResourcesRequestPage');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ContResourcesRequest', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/Create',
  name: 'MlOpsCreate',
  component: function component() {
    return import('@/apps/analytic-services/components/MlOpsCreate');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('MlOpsCreate', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/View/Pipeline/:request_id',
  name: 'MlOpsViewPipeline',
  component: function component() {
    return import('@/apps/analytic-services/components/MlOpsCreate');
  },
  meta: {
    mode: 'view',
    authentified: utils.getPermissiosInMenuDict('MlOpsCreate', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/Edit/Pipeline/:request_id',
  name: 'MlOpsEditPipeline',
  component: function component() {
    return import('@/apps/analytic-services/components/MlOpsCreate');
  },
  meta: {
    mode: 'edit',
    authentified: utils.getPermissiosInMenuDict('MlOpsCreate', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/View/Resource/:request_id',
  name: 'MlopsViewResource',
  component: function component() {
    return import('@/apps/analytic-services/components/TableCreate');
  },
  meta: {
    mode: 'view',
    authentified: utils.getPermissiosInMenuDict('TableCreate', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/TableCreate',
  name: 'TableCreate',
  component: function component() {
    return import('@/apps/analytic-services/components/TableCreate');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('TableCreate', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/Configs',
  name: 'MlopsConfigs',
  component: function component() {
    return import('@/apps/analytic-services/components/MlopsConfigs');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('MlopsConfigs', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/MlOps/Projects',
  name: 'MlopsProjects',
  component: function component() {
    return import('@/apps/analytic-services/components/MlopsProjects');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('MlopsProjects', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/ml/requests',
  name: 'ml_requests',
  component: function component() {
    return import('@/apps/analytic-services/modules/mlops/MLRequests');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ml_requests', MENU_ANALYTIC_SERVICES)
  }
}, {
  path: '/ml/pipelines',
  name: 'ml_pipelines',
  component: function component() {
    return import('@/apps/analytic-services/modules/mlops/Components');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ml_pipelines', MENU_ANALYTIC_SERVICES),
    check_flag: 'analytic-services/has_mlops_active'
  }
}, {
  path: '/ml/builder',
  name: 'ml_builder',
  component: function component() {
    return import('@/apps/analytic-services/modules/mlops/MLBuilder');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ml_builder', MENU_ANALYTIC_SERVICES),
    check_flag: 'analytic-services/has_mlops_active'
  }
}, {
  path: '/ml/create-template',
  name: 'ml_create_template',
  component: function component() {
    return import('@/apps/analytic-services/modules/mlops/CreateTemplate');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('ml_builder', MENU_ANALYTIC_SERVICES),
    check_flag: 'analytic-services/has_mlops_active'
  }
}];